import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import moment from 'moment'
import Loader from '../../elements/Loader'
import DataTable from '../../elements/DataTable'
import Pagination from '../../elements/Pagination'
import SearchField from '../../elements/SearchField'

import { fetchApplications } from '../../../store/actions/applicationsActions'
import { fetchAdmissions } from '../../../store/actions/admissionsActions'
import { ERROR } from '../../../store/types'
import { authHeader, baseUrl, transactionTimeStamp, debounce, applicationsDefaultDisplay, tableHeadersFields } from '../../../utils'
import EmptyState from '../../elements/EmptyState';
import ArrowUpTrayIcon from '../../elements/icons/ArrowUpTrayIcon';
import SquaresIcon from '../../elements/icons/SquaresIcon';
import ViewListIcon from '../../elements/icons/ViewListIcon';
import ApplicantTableSnippet from '../applications/ApplicantTableSnippet';
import ApplicationStatus from '../../elements/ApplicationStatus';
import ApplicationsFilters from '../../elements/filters/ApplicationsFilters';
import ApplicationCard from '../applications/ApplicationCard';

const ParentApplications = ({parent}) => {
  
  const dispatch = useDispatch()
  const applicationsSelector = useSelector((state => state.applications))
  const navigate = useNavigate()
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [reload, setReload] = useState(0);
  const [activeFilters, setActiveFilters] = useState(`parent=${parent?._id}`);

  useEffect(() => {
    dispatch(fetchApplications(activeFilters, page, perPage))
    dispatch(fetchAdmissions())
    return () => {
      
    };
  }, [page, perPage, dispatch, reload, activeFilters]);

  const tableOptions = {
    selectable: true,
    multiselect: true,
    clickableRows: true,
    rowAction: (rowIndex)=>{
      navigate(`/admin/administration/applications/${applicationsSelector.applications.applications[rowIndex]._id}`)
    }
  }

  const columnWidths = {
    applicant: 'w-3/12',
    applicationCode: 'w-2/12',
    class: 'w-1/12',
    appliedBy: 'w-1/12',
    admission: 'w-2/12',
    status: 'w-2/12',
    date: 'w-1/12',
  }

  const columnDataStyles = {}
  
  const cleanUpTableData = (array) => {
    if(!array) return
    let finalResult = [] 
    array.forEach((object, objectIndex) => {
        const applicationObject = {
          applicant: <ApplicantTableSnippet applicant={object} />,
          applicationCode: object.applicationCode,
          class: object.class,
          appliedBy: <p>{object?.parent?.firstName} {object?.parent?.lastName}</p>,
          admission: object?.admission?.title || '',
          status: <ApplicationStatus status={object.status} />,
          date: transactionTimeStamp(object.createdAt).date,
        }

        finalResult.push(applicationObject)
    })
    return finalResult
  }

  const [view, setView] = useState(applicationsDefaultDisplay() || 'list');
  const changeApplicationsView = (view) => {
    localStorage.setItem("applicationsDefaultDisplay", view);
    setView(view)
  }

  const [fetchingCsv, setFetchingCsv] = useState(false);

  const getApplicationsCsv = async (dateRange) => {
    try {
      const header = {
        headers: authHeader(),
        responseType: 'blob'
      }
      
      let url = `${baseUrl}/applications/export/csv?${activeFilters}`

      // if(filters && filters !== '') {
      //     url += `${url.includes('?') ? '&' : '?'}${filters}`
      // }

      setFetchingCsv(true)
      const response =  await axios.get(url, header ) 

      const blob = new Blob([response.data], {type: "application/csv"})
      const receiptUrl = window.URL.createObjectURL(blob)

      var link = document.createElement('a');
      link.href = receiptUrl;
      link.download = `vcm-applications-generated-${moment(new Date()).format('DD-MM-YYYY-h-mm-ss')}.csv`;
      setTimeout(() => {
          link.click();
      }, 100);
      setFetchingCsv(false)

    } catch (error) {
      console.error(error)
      setFetchingCsv(false)
      dispatch({
        type: ERROR,
        error
      })
    }
  }

  const searchApplicants = debounce((term) => {
    if(!term || term === '') setReload(reload + 1)
    dispatch(fetchApplications(`name=${term}&applicationCode=${term}`, 0, 0))
  })

  return (
    <div className='w-full'>
        <div className='w-full flex justify-between'>
            <div>
                <h3 className='text-lg font-medium'>Applications for Admission <span className='text-[12px] text-gray-400'>({applicationsSelector.applications.total} records)</span></h3>
                <p className='text-sm'>All applications for admission to Vaatia College, Makurdi</p>
            </div>
            <div>
            

            </div>
        </div>

        <div className='w-full flex items-start justify-between my-5 p-2 rounded-md border'>
            <div className='w-6/12'>
                <ApplicationsFilters applyFilters={(filters)=>{
                console.log('filters => ', filters)
                setActiveFilters(filters)
                }} />
            </div>
            <div className='w-6/12 flex flex-row-reverse gap-x-2'>
                <button onClick={()=>{getApplicationsCsv()}} className={`text-gray-700 px-2 py-2 hover:bg-gray-100 transition duration-200 text-sm flex items-center justify-center gap-x-2 bg-gray-200 rounded border`}>
                <ArrowUpTrayIcon className={`w-4 h-4`} />
                {fetchingCsv ? 'Exporting...' : `Export applications (${applicationsSelector.applications.total})`}
                </button>
                
                <button onClick={()=>{changeApplicationsView('grid')}} className={`${view === 'grid' ? 'text-gray-700' : 'text-gray-300'} p-1 rounded hover:bg-gray-100 transition duration-200`}>
                <SquaresIcon className={`w-6 h-6`} />
                </button>

                <button onClick={()=>{changeApplicationsView('list')}} className={`${view === 'list' ? 'text-gray-700' : 'text-gray-300'} p-1 rounded hover:bg-gray-100 transition duration-200`}>
                <ViewListIcon className={`w-6 h-6`} />
                </button>

                <div className='w-[350px]'>
                <SearchField 
                    placeholderText={`Search by applicant name or application code`}
                    showResultsDropDown={false}
                    triggerSearch={(term)=>{searchApplicants(term)}}
                    performingSearch={applicationsSelector.loadingApplications}
                />
                </div>
            </div>
        </div>

        {applicationsSelector.loadingApplications ? 
        <Loader />
        :
        <>
            {applicationsSelector.applications.applications.length > 0 ? <div className=''>
            {view === 'grid' && 
                <>
                <div className='mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-8'>
                    {applicationsSelector.applications.applications.map((application, applicationIndex)=>(
                    <div key={applicationIndex}>
                        <ApplicationCard application={application} />
                    </div>
                    ))}
                </div>

                <Pagination 
                    pagination={{
                    perPage, 
                    currentPage: page,
                    totalItems: applicationsSelector.applications.total,
                    }} 
                    changePage={setPage} 
                    updatePerPage={setPerPage}
                />
                </>
            }
            {view === 'list' && <div className='w-full'>
                <DataTable
                tableHeaders={tableHeadersFields(cleanUpTableData(applicationsSelector.applications.applications)[0]).headers} 
                tableData={cleanUpTableData(applicationsSelector.applications.applications)} 
                columnWidths={columnWidths}
                columnDataStyles={columnDataStyles}
                allFields={tableHeadersFields(cleanUpTableData(applicationsSelector.applications.applications)[0]).fields}
                onSelectItems={()=>{}}
                tableOptions={tableOptions}
                pagination={{
                    perPage, 
                    currentPage: page,
                    totalItems: applicationsSelector.applications.total,
                }}
                onSelectSingle={()=>{}}
                changePage={setPage}
                updatePerPage={setPerPage}
                />
            </div>
            }
            </div>
            : 
            <div className='mt-24 w-1/2 mx-auto'>
                <EmptyState emptyStateText={`There are no applications yet!`} />
            </div>

            }
        </>
        }
    </div>
  )
}

export default ParentApplications